import React, {useEffect, useLayoutEffect, useState} from 'react';
import withRequest from "../../../hoc/withRequest";
import {useMacro} from "../../../components/hooks";
import {Backdrop, CircularProgress} from "@mui/material";
import {Alert, ErrorScreen} from "../../../components/common";
import MacroFormDumb from "./MacroFormDumb";
import {ROUTES} from "../../../consts";
import {useHistory} from "react-router-dom";
import { servicePostMacro } from 'utils';

const MacroFormSmart = (props) => {
  const { cleanUpMessage, error, success, data, isLoaded, getFieldData, fieldData, executeMacro  } = useMacro();
  const [dataLoaded, setDataLoaded] = useState(false);
  const history = useHistory();
  const [defaultValues, setDefaultValues] = useState({
    name: '',
    description: '',
    inventory: '',
    type: 'create',
    hosts: '',
    credential: '',
    configFile: '',
    configFileSelect: '',
  });

  useLayoutEffect(() => {
    const query = {};
    query.search = '';
    getFieldData({query})
    //getMacro();
  }, []);

  useEffect(() => {
    if (success.post && data?.job_id) {
      history.push(`${ROUTES.JOB_RUN_TEMPLATE}/${data.job_id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  const handleCloseAlert = () => cleanUpMessage();

  const handleExecute = (data) => {
    //executeMacro(data);
    if (!data.hosts) data.hosts = 'all';

    servicePostMacro(data)
      .then((response) => {
        if (response.data.job_id) {
          history.push(`${ROUTES.JOB_RUN_TEMPLATE}/${response.data.job_id}`);
        }
      })
      .catch((err) => {
        alert("Error");
        console.error(err);
      });
  }

  const alerts = [
    {
      severity: 'error',
      open: error.post,
      message: 'macro.components.alert.error',
    }
  ];
  
  return (
    <>
      {isLoaded.get ?
        (
          <Backdrop invisible sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }} open={true}>
            <CircularProgress color="primary" />
          </Backdrop>
        ): (fieldData.inventories && fieldData.credentials && fieldData.configFiles) ?
        (
          <MacroFormDumb defaultValues={defaultValues} handleExecute={handleExecute} fieldData={fieldData}/>
        )
        :(
          <></>
        )
      }
      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}
    </>
  );

}

export default withRequest(MacroFormSmart);
